import { sankey } from 'd3-sankey';

const getSankeySize = (sankeyData, align, idKey = 'id') => {
  const { nodes, links } = sankeyData;
  const nodesCopy = nodes.map((d) => ({ ...d }));
  const linksCopy = links.map((l) => ({ ...l }));

  const sankeyGen = sankey()
    .nodeWidth(45)
    .nodePadding(80)
    .nodeAlign(align)
    .nodeId((node) => {
      if (idKey && node[idKey]) {
        return node[idKey];
      }
      return node.id;
    });

  try {
    sankeyGen({ nodes: nodesCopy, links: linksCopy });
  } catch (error) {
    console.log(error);
  }

  const maxDepth = Math.max(...nodesCopy.map((node) => node.depth));

  const depthValueMap = {};

  nodesCopy.forEach((node) => {
    const d = node.depth;
    depthValueMap[d] = (depthValueMap[d] || 0) + 1;
  });

  const maxTotalValue = Math.max(...Object.values(depthValueMap));

  const width = (maxDepth + 1) * 350; // Assuming each layer is 350px wide
  const height = maxTotalValue * 100 + 30; // Assuming each node is 100px tall, 30 for scroll bar

  return {
    width,
    height,
  };
};

export default getSankeySize;
